import { IStatusPanelComp, IStatusPanelParams } from '@ag-grid-community/core'
import {
  ChangeDetectorRef,
  ComponentFactoryResolver,
  ComponentRef,
  Injector,
} from '@angular/core'
import { TotalRowsStatusComponent } from './total-rows-status.component'

export class TotalRowsCountStatusBar implements IStatusPanelComp {
  private componentRef!: ComponentRef<TotalRowsStatusComponent>

  /** @internal */
  readonly filterChangedListener = () => this.onFilterChanged()

  init(params: IStatusPanelParams): void {
    const resolver = params.context.resolver as ComponentFactoryResolver
    const cd = params.context.changeDetector as ChangeDetectorRef

    const injector = Injector.create({
      providers: [
        {
          provide: ChangeDetectorRef,
          useValue: cd,
        },
        {
          provide: 'RowCountRequestGetter',
          useValue: () => params.context.getRowCountRequest(params.api),
        },
      ],
    })
    this.componentRef = resolver
      .resolveComponentFactory(TotalRowsStatusComponent)
      .create(injector)
    this.onFilterChanged()

    params.api.addEventListener('filterChanged', this.filterChangedListener)
  }

  getGui(): HTMLElement {
    return this.componentRef.location.nativeElement
  }

  destroy() {
    this.componentRef.instance.destroy()
  }

  /** @internal */
  onFilterChanged() {
    this.componentRef.instance.updateCounts()
  }
}
